module.exports = __webpack_public_path__ + "img/icon_change.f7d17bbc.png";